export default "__VITE_ASSET__0c98c5fa__"